import React from "react";

interface Props {
  useErrorState: [string, React.Dispatch<React.SetStateAction<string>>];
}

const ErrorContainer: React.FC<Props> = (props) => {
  const [errorMessage, setErrorMessage] = props.useErrorState;

  return errorMessage ? (
    <div className={`error-container`}>
      <span className="error-close" onClick={() => setErrorMessage("")}>
        &#10005;
      </span>
      <div className="error-message">{errorMessage}</div>
    </div>
  ) : null;
};

export default ErrorContainer;
